import { useCallback } from 'react';
import { IParamsInitial, useFiltersContext } from '@/creditflowresearch/application/FiltersContext';
import { useBondsAssetClassesContext } from '@/creditflowresearch/application/Bonds/BondsAssetClassesContext';
import { useBondsFiltersContext } from '@/creditflowresearch/application/Bonds/BondsFiltersContext';

const useGetBondsPayload = () => {
  const { filtersPayload } = useBondsFiltersContext();
  const { params } = useFiltersContext();
  const { currentAssetClass } = useBondsAssetClassesContext();

  const getPayload = useCallback((
      { assetClassId, params: propsParams }: { assetClassId?: string, params?: IParamsInitial },
  ) => (
      {
        ...params,
        ...propsParams,
        search: propsParams?.search !== undefined ? propsParams.search : params.search,
        filter: {
          ...filtersPayload,
          includedAssetClassId: assetClassId || currentAssetClass?.id,
        },
      }
  ), [params, filtersPayload, currentAssetClass]);

  return { getPayload };
};

export default useGetBondsPayload;
